module.exports = __webpack_public_path__ + "img/curso-marca-personal.dd4eedf3.png";